module.exports = __webpack_public_path__ + "static/media/fsobp_logo_border_500.4acd9385.png";